import { PositiveColors, TextColors } from '@picsart/design-system/foundation/colors';
import { TypographyT4, TypographyT5 } from '@picsart/design-system/foundation/typography';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { color: string }>(
  {
    root: {
      display: 'flex',
      gap: Spacings.s32,

      '@media screen and (max-width: 768px)': {
        flexDirection: 'column',
        gap: Spacings.s40,
      },
    },

    textContainer: {
      display: 'flex',
      paddingRight: Spacings.s10,
    },

    colorContainer: {
      minWidth: '50%',
      padding: [Spacings.s24, Spacings.s32],

      '@media screen and (max-width: 480px)': {
        padding: 0,
      },
    },

    background: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: ({ color }) => color,
      backgroundImage:
        'url(https://pastatic.picsart.com/cms-pastatic/e8c04289-21d2-48df-9172-648dc617c3b7.png)',
      borderRadius: CornerRadius.r16,
      height: 419,
      position: 'relative',
    },

    nameContainer: {
      backgroundColor: PositiveColors.base.default,
      borderRadius: CornerRadius.r16,
      padding: Spacings.s6,
      width: 'fit-content',
    },

    name: {
      color: TextColors.base,
      display: 'flex',
      flexDirection: 'column',
      height: 80,
      padding: Spacings.s16,
    },

    color: {
      backgroundColor: ({ color }) => color,
      borderRadius: [CornerRadius.r16, CornerRadius.r16, 0, 0],
      height: 185,
      width: 190,
    },

    logo: {
      bottom: Spacings.s24,
      position: 'absolute',
      right: Spacings.s24,

      '@media screen and (max-width: 480px)': {
        bottom: Spacings.s16,
        right: Spacings.s16,
        width: 82,
      },
    },

    title: {
      '@media screen and (max-width: 480px)': {
        ...TypographyT5,
      },
    },

    hex: {
      '@media screen and (max-width: 480px)': {
        ...TypographyT4,
      },
    },
  },
  {
    name: 'color-with-text',
  },
);

export default useStyles;
